import PerfMarker from '../store/schema/PerfMarker';
import store from '../store/Store';
import { owaDate } from 'owa-datetime';
import { trace } from 'owa-trace';
import { mutator } from 'satcheljs';
import {
    addCard,
    removeCard,
    setAutoInvokeActionAlreadyRan,
    markPerfCheckpoint,
    updatePerfCheckpointsBeforeUpdatingAutoInvokeResponse,
    setTotalFetchTimeForCard,
} from '../actions/cardActions';

export const addCardMutator = mutator(addCard, actionMessage => {
    store.cards.set(actionMessage.cardId, {
        actionInProgress: false,
        actionResponseMessage: '',
        actionResponseDate: '',
        showActionResponse: false,
        perfCheckpoints: {
            currentCardCheckpoints: {},
        },
    });
});

export const removeCardMutator = mutator(removeCard, actionMessage => {
    store.cards.delete(actionMessage.cardId);
});

export const setAutoInvokeActionAlreadyRanMutator = mutator(
    setAutoInvokeActionAlreadyRan,
    actionMessage => {
        const card = store.cards.get(actionMessage.cardId);
        if (card) {
            card.autoInvokeActionAlreadyRan = actionMessage.autoInvokeActionAlreadyRan;
        } else {
            trace.warn(
                `[ActionableMessageDebug] setAutoInvokeActionAlreadyRanMutator: card is undefined for cardId ${actionMessage.cardId}`
            );
        }
    }
);

export const markPerfCheckpointMutator = mutator(markPerfCheckpoint, actionMessage => {
    const card = store.cards.get(actionMessage.cardId);
    if (card) {
        const time = actionMessage.time || owaDate();
        switch (actionMessage.perfMarker) {
            case PerfMarker.LoadStart:
                card.perfCheckpoints.loadStart = time;
                break;
            case PerfMarker.AutoInvokeActionStart:
                card.perfCheckpoints.autoInvokeActionStart = time;
                break;
            case PerfMarker.AutoInvokeActionEnd:
                card.perfCheckpoints.autoInvokeActionEnd = time;
                break;
            case PerfMarker.CardRenderStart:
                card.perfCheckpoints.currentCardCheckpoints.cardRenderStart = time;
                break;
            case PerfMarker.CardRenderEnd:
                card.perfCheckpoints.currentCardCheckpoints.cardRenderEnd = time;
                break;
            case PerfMarker.ThemeLoadTotalStart:
                card.perfCheckpoints.currentCardCheckpoints.themeLoadTotalStart = time;
                break;
            case PerfMarker.ThemeLoadTotalEnd:
                card.perfCheckpoints.currentCardCheckpoints.themeLoadTotalEnd = time;
                break;
            case PerfMarker.ThemeDefinitionsLoadStart:
                card.perfCheckpoints.currentCardCheckpoints.themeDefinitionsLoadStart = time;
                break;
            case PerfMarker.ThemeDefinitionsLoadEnd:
                card.perfCheckpoints.currentCardCheckpoints.themeDefinitionsLoadEnd = time;
                break;
            case PerfMarker.ThemeResolveStart:
                card.perfCheckpoints.currentCardCheckpoints.themeResolveStart = time;
                break;
            case PerfMarker.ThemeResolveEnd:
                card.perfCheckpoints.currentCardCheckpoints.themeResolveEnd = time;
                break;
            case PerfMarker.CardCreateStart:
                card.perfCheckpoints.currentCardCheckpoints.cardCreateStart = time;
                break;
            case PerfMarker.CardCreateEnd:
                card.perfCheckpoints.currentCardCheckpoints.cardCreateEnd = time;
                break;
            case PerfMarker.CardLibraryRenderStart:
                card.perfCheckpoints.currentCardCheckpoints.cardLibraryRenderStart = time;
                break;
            case PerfMarker.CardLibraryRenderEnd:
                card.perfCheckpoints.currentCardCheckpoints.cardLibraryRenderEnd = time;
                break;
            case PerfMarker.PrepareCardStart:
                card.perfCheckpoints.currentCardCheckpoints.prepareCardStart = time;
                break;
            case PerfMarker.PrepareCardEnd:
                card.perfCheckpoints.currentCardCheckpoints.prepareCardEnd = time;
                break;
            default:
                trace.info(
                    'Actionable Message Card: markPerfCheckpointMutator called with unexpected PerfMarker'
                );
                break;
        }
    }
});

export const setTotalFetchTimeForCardMutator = mutator(setTotalFetchTimeForCard, actionMessage => {
    const card = store.cards.get(actionMessage.cardId);
    if (card?.perfCheckpoints?.currentCardCheckpoints) {
        card.perfCheckpoints.currentCardCheckpoints.totalFetchTime = actionMessage.totalFetchTime;
    }
});

export const updateTelemetryDataBeforeAutoInvokeMutator = mutator(
    updatePerfCheckpointsBeforeUpdatingAutoInvokeResponse,
    actionMessage => {
        const card = store.cards.get(actionMessage.cardId);
        if (card?.perfCheckpoints) {
            card.perfCheckpoints.previousCardCheckpoints =
                card.perfCheckpoints.currentCardCheckpoints;
            card.perfCheckpoints.currentCardCheckpoints = {};
        }
    }
);
